import { useContext } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { getDomainValueForCode } from '../../../../library/Core/SmartFunctions';

const TopMembersTeamTable = () => {
    const { state } = useContext(SmartContext);
    const members = state.data.topMembersTeam;

    return (
        <div className="bg-white p-4 custom-shadow h-100 radius-6">
            <h5 className="col font-18 font-600 mb-3">Top Members</h5>
            {members.length === 0 ? (
                <p className="font-14 text-gray-64">No team member data available.</p>
            ) : (
                <div className="d-flex flex-column gap-2 overflow-y-auto pe-1" style={{ maxHeight: '268px' }}>
                    {members.map((member: any, index: number) => (
                        <div
                            key={index}
                            className="d-flex justify-content-between align-items-center border rounded-3 px-3 py-2">
                            <div>
                                <div className="font-500 text-dark" style={{ fontSize: '0.95rem' }}>
                                    {member.name}
                                </div>
                                <div className={`text-${member.departmentColor || 'success'}`} style={{ fontSize: '0.8rem' }}>
                                    {getDomainValueForCode(member.department, 'OUTREACH_TEAM_CODE', state)}
                                </div>
                            </div>
                            <div className="text-end">
                                <div className="font-500 text-dark" style={{ fontSize: '0.95rem' }}>
                                    {member.attempts} attempts
                                </div>
                                <div className="text-secondary" style={{ fontSize: '0.78rem' }}>
                                    {member.duration}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TopMembersTeamTable;
